import produce from 'immer';
import { getRealPatternFromPrefixes } from '../../components/Utils/NodeUtils';
import { getTypeOfField } from '../../components/Utils/Utils.js';
import { joinPattern, splitPattern } from '../../components/Utils/TextUtils.js';

import { events } from '../../constants/event';
import { fixed_field_type } from '../../constants/field';
import { BANDS_CONFIG, NUM_LEVEL } from '../../constants/layout';
import {
  calculateGirlViewAdditionalColumn,
  collectNamerefProperties,
  extractDicoFormObjFormData,
  extractDicoFullFormObjFormData,
  getTodayDate,
  preParseDataOpenPerspective,
  replaceObj,
  retrieveObj,
  findNodeByKey,
} from '../../utils/commonFunctionObjectsReducer';
import { OBJECTS_TYPE } from './type';
import { parseJson } from '../../utils/parseJson.js';
import { DEFAULT_QB_RESTRICTIONS } from '../queryBuilderReducers.js';
import config from '../../config.json';

let res;
const contextTable = ['nbChild', 'nbRandom', 'meteo', 'document', 'risk'];
const stackingEnabled = config.objectConfig.stackingEnabled;
const allowManualStacking = config.objectConfig.allowManualStacking;

const objects = (
  state = {
    autoVertPos: false,
    autoVertPosMS: 15000,
    timeLineCentralDate: Array.from({ length: NUM_LEVEL }, () => -1), //  [-1, -1, -1, -1, -1],

    currObjNbrChilds: -1,
    fathers: [],
    paging_excluded: ['ids1', 'id2'],
    paging_map: [{ objId: 'cli', skip: 5 }],
    nodes_position: [],
    objectsDefList: [],
    isLoadingObjectsDefList: false,
    childsCountByType: Array.from({ length: NUM_LEVEL }, () => []), // [[], [], [], [], []], // by level
    isGettingState: false,
    objectsReceived: [],
    field_type: fixed_field_type,
    cue: 1000,
    selectedConfig: 'config1',
    pattern: joinPattern(Array.from({ length: NUM_LEVEL }, () => ['none'])),
    levels: NUM_LEVEL,
    restrictions: [],
    viewFilters: [],
    viewFiltersRestriction: [],
    viewFiltersConfig: [],
    timeline_shift: Array.from({ length: NUM_LEVEL }, () => 0), //  [0, 0, 0, 0, 0],
    crumbTrail: null,
    menuPosX: 0,
    menuPosY: 0,
    isFetching: false,
    context: 'nbChild',
    contextInd: 0,
    classifX: 'assignee',
    classifY: null,
    globalValues: { aaa: 0 },
    filters: Object.fromEntries(
      Array.from({ length: NUM_LEVEL }, (_, i) => [`level${i}`, 'none'])
    ), // { level0: 'none', level1: 'none', … level4: 'none' }

    hoverNode: 'XXXOOOXXXX',
    loggedUser: null,
    dragged_node_key: null,
    dragged_over: null,
    dragged_node_origin_panel: null,
    events: events,
    filteredNodes: [],
    nodes: [],
    collapsedNodes: [],
    layers: [],
    objDefFormData: [],
    objFormData: [],
    objFormFieldEdited: 'random',
    objLayersRead: [], // layers attached to the objForm selected
    objLayersWrite: [],
    usedLayers: [],
    dicoNameRef: {},
    dicoFullRef: {},
    arrayParamClassif: [],
    arrayParamClassifDetails: [],
    arrayStatBy: Array.from({ length: NUM_LEVEL }, () => 'effort'),
    arraySortBy: Array.from({ length: NUM_LEVEL }, () => 'status'),
    arraySortByWithType: Array.from({ length: NUM_LEVEL }, () => {
      return { key: 'name', type: 'text' };
    }),
    // XXX SHOULD REPLACE arraySortBy

    arrayClassifBy: Array.from({ length: NUM_LEVEL }, () => 'default'), // ['default', 'default', 'default', 'default', 'default'],
    displayMode: Array.from({ length: NUM_LEVEL }, () => 'card'), //  ['card', 'card', 'card', 'card', 'card'],
    dataColumns: Array.from({ length: NUM_LEVEL }, () => []),
    dataLines: Array.from({ length: NUM_LEVEL }, () => []),
    profiles: [],
    activePanel: 0,
    activePanelHeader: -1, // to hightlight node of the panel when user is in the header
    activeBand: null,
    objId: null,
    objTypeId: null,
    objStack: [], // used to store references when an object is open from anohter one
    objToCreate: null,
    perspectiveId: null,
    perspectiveName: '[----]',
    arraycolor: '#1C7ED6',
    arraytype: 'classic',
    openModule: 'INV',
    perspectives: [],
    templateObjects: [],
    isLoadingPerspectives: true,
    panels: BANDS_CONFIG,
    configure_objId: null,
    social_content: [],
    scrollListeners: [],
    initDone: false,
    isLoadingCrumbTrail: false,
    isOpenActivityFromVertical: false,
    isLoadingObjData: false,
    isLoadingTree: Array.from({ length: NUM_LEVEL }).reduce((acc, _, i) => {
      acc[i] = false;
      return acc;
    }, {}), // { 0: false, 1: false, 2: false },

    isLoadingObjectConfig: false,
  },
  action,
  root
) => {
  switch (action.type) {
    case OBJECTS_TYPE.INIT_DONE:
      return produce(state, (draft) => {
        draft.initDone = true;
      });

    case OBJECTS_TYPE.SET_TIMELINE_CENTRAL_DATE: {
      if (typeof action.level !== 'undefined') {
        return produce(state, (draft) => {
          draft.timeLineCentralDate[action.level] = action.value;
          draft.timeline_shift[action.level] = 0;
        });
      }
      return state;
    }

    case OBJECTS_TYPE.SET_LOADING_RECEIVE_TREE: {
      if (typeof action.level !== 'undefined') {
        return produce(state, (draft) => {
          draft.isLoadingTree[action.level] = action.value;
        });
      }
      return state;
    }

    case OBJECTS_TYPE.SET_PAGING:
      return produce(state, (draft) => {
        const { objId } = action;
        const newValue =
          (draft.paging_map.find((a) => a.objId === objId)?.skip ?? 0) + 5;
        let newMap = draft.paging_map.filter((a) => a.objId !== objId);
        newMap = [...newMap, { objId: action.objId, skip: newValue }];
        const paging_excluded = [
          ...draft.paging_excluded,
          ...retrieveObj(draft.nodes, action.objId)?.children?.map(
            (item) => item.key
          ),
        ];
        draft.paging_map = newMap;
        draft.paging_excluded = [...new Set(paging_excluded)];
      });
    case OBJECTS_TYPE.GET_STATE:
      return produce(state, (draft) => {
        draft.isGettingState = true;
      });
    case OBJECTS_TYPE.RECEIVED_STATE:
      return produce(state, (draft) => {
        draft = action.objects;
        draft.isGettingState = true;
      });
    case OBJECTS_TYPE.SET_NODES_POSITION:
      return produce(state, (draft) => {
        const { nodes } = action;
        const allNodes = [...nodes];
        const res = [];
        while (allNodes.length > 0) {
          const elem = allNodes.pop();
          res.push({
            key: elem.data.key,
            x: elem.x,
            y: elem.offsetY,
            data: elem.data,
            height: elem.ySize,
            depth: elem.depth,
          });
          if (elem.children) {
            allNodes.push(...elem.children);
          }
        }
        draft.nodes_position = res;
      });
    case OBJECTS_TYPE.GOT_NBR_CHILD:
      return produce(state, (draft) => {
        draft.currObjNbrChilds = action.objects.nbrChilds;
      });
    case OBJECTS_TYPE.ADD_SCROLLLISTENER:
      return produce(state, (draft) => {
        draft.scrollListeners.push(action.callback);
      });
    case OBJECTS_TYPE.REMOVE_SCROLLLISTENER:
      return produce(state, (draft) => {
        draft.scrollListeners = draft.scrollListeners.filter(
          (a) => a !== action.callback
        );
      });
    case OBJECTS_TYPE.CONFIGURE_SELECT_TAB:
      return produce(state, (draft) => {
        draft.configure_tab = action.ind;
      });
    case OBJECTS_TYPE.SET_ACTIVE_PANEL:
      return produce(state, (draft) => {
        draft.activePanel = action.level;
        draft.classifX = draft.arrayClassifBy[action.level];
      });

    case OBJECTS_TYPE.SET_ACTIVE_PANEL_HEADER:
      return produce(state, (draft) => {
        draft.activePanelHeader = action.level;
      });

    case OBJECTS_TYPE.SET_ACTIVE_BAND:
      return produce(state, (draft) => {
        draft.activePanel = action.level;
        draft.activeBand = action.band;
      });
    case OBJECTS_TYPE.SET_SORT_BY:
      return produce(state, (draft) => {
        draft.arraySortBy[action.level] = action.sortKey;
        let colType = splitPattern(draft.pattern)[action.level];
        let typeOfField = getTypeOfField(
          draft.objectsDefList,
          colType,
          action.sortKey
        );

        draft.arraySortByWithType[action.level] = {
          key: action.sortKey,
          type: typeOfField ?? 'text',
        };
      });

    case OBJECTS_TYPE.TOGGLE_MANDATORY_LEVEL:
      return produce(state, (draft) => {
        draft.mandatoryLevel =
          draft.mandatoryLevel === `${action.level}`
            ? `${action.level - 1}`
            : `${action.level}`;
      });

    case OBJECTS_TYPE.TOGGLE_DISPLAY_MODE:
      return produce(state, (draft) => {
        const modes =
          stackingEnabled && allowManualStacking
            ? ['grid', 'card', 'stack']
            : ['grid', 'card'];
        const current = draft.displayMode[action.level];
        const currentIndex = modes.indexOf(current);

        draft.displayMode[action.level] =
          modes[(currentIndex + 1) % modes.length];
      });

    case OBJECTS_TYPE.SET_DISPLAY_MODE:
      return produce(state, (draft) => {
        draft.displayMode[action.level] = action.mode;
        draft.dataColumns = draft.dataColumns.reduce((arr, item, ind) => {
          if (
            draft.displayMode[ind].includes('grid') ||
            draft.displayMode[ind].includes('stack')
          )
            arr.push(item);
          else arr.push([]);
          return arr;
        }, []);
        draft.dataLines = draft.dataColumns.reduce((arr, item, ind) => {
          if (draft.displayMode[ind].includes('card')) arr.push(item);
          else arr.push([]);
          return arr;
        }, []);
        draft.arrayClassifBy = draft.arrayClassifBy.reduce((arr, item, ind) => {
          draft.displayMode[ind] === 'card'
            ? arr.push(item)
            : arr.push('default');
          return arr;
        }, []);
        draft.classifX =
          action.mode === 'grid' || action.mode === 'stack'
            ? 'default'
            : draft.arrayClassifBy[action.level];
      });
    case OBJECTS_TYPE.SET_STAT_BY:
      return produce(state, (draft) => {
        draft.arrayStatBy[action.level] = action.statKey;
        draft.arrayClassifBy[action.level] = action.statKey;
        draft.classifX = action.statKey;
      });

    case OBJECTS_TYPE.SET_ARRAY_PARAM_CLASSIF:
      return produce(state, (draft) => {
        draft.arrayParamClassif = action.arrayParamClassif;
        draft.arrayParamClassifDetails = action.arrayParamClassifDetails;
      });

    case OBJECTS_TYPE.RESET_ACTIVE_PANEL:
      return produce(state, (draft) => {
        draft.activePanel = 0;
      });
    case OBJECTS_TYPE.SET_CUE:
      return produce(state, (draft) => {
        draft.cue = action.value;
      });
    case OBJECTS_TYPE.COLLAPSE_NODE:
      return produce(state, (draft) => {
        draft.collapsedNodes.push(action.objId);
      });
    case OBJECTS_TYPE.COLLAPSE_NODES:
      return produce(state, (draft) => {
        draft.collapsedNodes.push(...action.nodes);
      });
    case OBJECTS_TYPE.EXPAND_NODE:
      return produce(state, (draft) => {
        draft.collapsedNodes = draft.collapsedNodes.filter(
          (e) => e !== action.objId
        );
      });
    case OBJECTS_TYPE.EXPAND_NODES:
      return produce(state, (draft) => {
        draft.collapsedNodes = draft.collapsedNodes.filter(
          (e) => !action.nodes.includes(e)
        );
      });
    case OBJECTS_TYPE.SEC_CURRENT_CONFIG:
      return produce(state, (draft) => {
        draft.selectedConfig = action.value;
      });

    case OBJECTS_TYPE.TIMELINE_SHIFT:
      return produce(state, (draft) => {
        draft.timeline_shift[action.level] += action.shift;
      });

    case OBJECTS_TYPE.UPDATE_DATA_COLUMN_SIZE: {
      const { level, column, width } = action;
      return produce(state, (draft) => {
        draft.dataColumns[level][column].w = Math.max(60, width);
      });
    }

    case OBJECTS_TYPE.UPDATE_DATA_COLUMN_SIZE_BY_TYPE_NAME: {
      const { typeTo, name, width } = action;
      const targetWidth = Math.max(60, Number(width) || 0);

      return produce(state, (draft) => {
        const levels = draft.dataColumns || [];
        for (let lvl = 0; lvl < levels.length; lvl++) {
          const cols = levels[lvl];
          if (!Array.isArray(cols)) continue;

          for (let i = 0; i < cols.length; i++) {
            const col = cols[i];
            if (col && col.to === typeTo && col.data === name) {
              col.w = targetWidth;
            }
          }
        }
      });
    }

    case OBJECTS_TYPE.TOGGLE_ADDITIONAL_COLUMN: {
      const { objectType, column } = action;
      let activePanelDataColumns = state.dataColumns[state.activePanel];
      activePanelDataColumns = activePanelDataColumns.filter(
        (a) => a.data !== action.column
      );
      const isElemRemoved =
        activePanelDataColumns.length !==
        state.dataColumns[state.activePanel].length;
      if (!isElemRemoved) {
        if (column === 'layers') {
          for (const aLayerInd in state.layers) {
            const aLayer = state.layers[aLayerInd];
            activePanelDataColumns.push({
              w: 60,
              to: objectType,
              data: 'layers',
              type: 'yesno',
              operation: 'contains',
              value: aLayer.key,
              attrName: aLayer.name,
            });
          }
        } else {
          const typeOfficial = getTypeOfField(
            state.objectsDefList,
            objectType,
            column
          );
          activePanelDataColumns = calculateGirlViewAdditionalColumn({
            typeOfficial,
            activePanelDataColumns,
            objectType,
            column,
          });
        }
      }

      const arrayDataColumns = [...state.dataColumns];
      arrayDataColumns[state.activePanel] = activePanelDataColumns;
      return { ...state, dataColumns: arrayDataColumns };
    }

    case OBJECTS_TYPE.TOGGLE_ADDITIONAL_LINE: {
      // ndl = new data line to be displyaed in node
      let activePanelDataLines = [];
      try {
        if (state.dataLines && state.dataLines[state.activePanel]) {
          activePanelDataLines = state.dataLines[state.activePanel];
        }
      } catch (e) {}

      activePanelDataLines = activePanelDataLines.filter(
        (a) => a.data !== action.line
      );
      const isElemRemoved =
        activePanelDataLines.length !==
        state.dataLines[state.activePanel]?.length;
      if (!isElemRemoved) {
        if (action.line !== 'layers') {
          activePanelDataLines = [
            ...activePanelDataLines,
            { to: action.objectType, data: action.line, h: 1, type: 'text' },
          ];
        }
      }

      const arrayDataLines = [...state.dataLines];
      arrayDataLines[state.activePanel] = activePanelDataLines;
      return { ...state, dataLines: arrayDataLines };
    }

    case OBJECTS_TYPE.RESET_ADDITIONAL_LINES:
      return produce(state, (draft) => {
        draft.dataLines[draft.activePanel] = [];
      });
    case OBJECTS_TYPE.RESET_ADDITIONAL_COLUMNS:
      return produce(state, (draft) => {
        draft.dataColumns[draft.activePanel] = [];
      });
    case 'CHECK_LOGIN':
      return produce(state, (draft) => {
        draft.loggedUser = '';
        draft.nodes = [];
      });
    case OBJECTS_TYPE.SET_HOVER_NODE:
      return produce(state, (draft) => {
        draft.hoverNode = action.objId;
      });
    case OBJECTS_TYPE.CLEAR_FIELD_RESTRICTION:
      return produce(state, (draft) => {
        draft.restrictions = [];
      });
    case OBJECTS_TYPE.ADD_FIELD_RESTRICTION:
      return produce(state, (draft) => {
        const newRest = [
          ...draft.restrictions,
          {
            [action.field]: action.value,
            objectType: action.objectType,
            comparator: action.comparator,
          },
        ];
        draft.restrictions = newRest;
      });
    case OBJECTS_TYPE.CREATED_FROM_OBJ_DEF:
      return produce(state, (draft) => {
        draft.objId = action.objects[0].newObjId;
      });

    case OBJECTS_TYPE.CREATED_FROM_TEMPLATE_OBJECT:
      return produce(state, (draft) => {
        draft.objId = action.objects[0].newObjId;
      });
    case OBJECTS_TYPE.POST_CREATED_FROM_OBJ_DEF:
      return produce(state, (draft) => {});

    case OBJECTS_TYPE.CREATED_PERSP_FROM_OBJ_DEF:
      return produce(state, (draft) => {
        draft.objId = action.objects[0].newObjId;
        draft.perspectiveId = action.objects[0].newObjId;
      });

    case OBJECTS_TYPE.LINK_FIELD:
      let fieldName = action.fieldName;
      let attrNameToLink = root.OBJECT_SELECTOR.attrNameSelected.trim();
      let drawingToLink = root.OBJECT_SELECTOR.selectedDrawingItem.trim();
      let selectedObject =
        root.OBJECT_SELECTOR.objectSelectorState.idSelectedObject.trim();

      // we find the index and default value of the field from the global object
      const svgToLinkPadIndex = root.objects.objFormData.findIndex(
        (obj) => obj.attrName.trim() === attrNameToLink
      );
      let defaultValueStrToLink =
        root.objects.objFormData[svgToLinkPadIndex].value;
      let defaultValueObjToLink = parseJson(defaultValueStrToLink);

      let drawingToLinkInd = defaultValueObjToLink.findIndex(
        (obj) => obj.key === drawingToLink
      );

      // in the default value we set the link
      defaultValueObjToLink[
        drawingToLinkInd
      ].points = `${selectedObject}|${fieldName}`;
      defaultValueObjToLink[
        drawingToLinkInd
      ].calculated = `${selectedObject}|${fieldName}`;

      // we udpate the object with the new value with the link
      return produce(state, (draft) => {
        draft.objFormData[svgToLinkPadIndex].value = JSON.stringify(
          defaultValueObjToLink
        );
        draft.objFormData[svgToLinkPadIndex].defaultValue = JSON.stringify(
          defaultValueObjToLink
        );
      });

    case OBJECTS_TYPE.LINK_OBJECT:
      let attrNameSelected = root.OBJECT_SELECTOR.attrNameSelected.trim();
      let selectedDrawingItem = root.OBJECT_SELECTOR.selectedDrawingItem.trim();
      // we find the index and default value of the field from the global object
      const svgPadIndex = root.objects.objFormData.findIndex(
        (obj) => obj.attrName.trim() === attrNameSelected
      );
      let defaultValueStr = root.objects.objFormData[svgPadIndex].value;
      let defaultValueObj = parseJson(defaultValueStr);

      let selectDrawingItemInd = defaultValueObj.findIndex(
        (obj) => obj.key === selectedDrawingItem
      );

      // in the default value we set the link
      defaultValueObj[selectDrawingItemInd].link = action.objId;

      // we udpate the object with the new value with the link
      return produce(state, (draft) => {
        draft.objFormData[svgPadIndex].value = JSON.stringify(defaultValueObj);
        draft.objFormData[svgPadIndex].defaultValue =
          JSON.stringify(defaultValueObj);
      });

    case OBJECTS_TYPE.DELETE_OBJECT:
      return produce(state, (draft) => {
        draft.objFormData = '';
        draft.objId = '';
      });

    case OBJECTS_TYPE.UNSTACK_OBJECT:
      return produce(state, (draft) => {
        const poped = draft.objStack.pop();
        draft.objId = poped.objId;
        draft.objTypeId = poped.objTypeId;
      });
    case OBJECTS_TYPE.STACK_OBJECT:
      return produce(state, (draft) => {
        draft.objStack.push({ objId: draft.objId, objTypeId: draft.objTypeId });
      });
    case OBJECTS_TYPE.SELECT_OBJECT:
      return produce(state, (draft) => {
        draft.objId = action.objId ?? '';
        draft.objTypeId = action.objId ? draft.objTypeId : '';
        draft.objStack = [];
      });
    case OBJECTS_TYPE.SELECTED_OBJECT:
      return produce(state, (draft) => {
        draft.objFormData = action.objects.objFormData;
        // draft.objLayers = action.objects.layers;
        draft.objLayersRead = action.objects.layersRead;
        draft.objLayersWrite = action.objects.layersWrite;
        draft.objTypeId = action.objects.type;
        draft.objId = action.objects.objId ?? draft.objId;
        draft.buttons = action.objects.buttons;
        draft.workflow = action.objects.workflow;
        draft.state = action.objects.state;
        draft.nodes = replaceObj(
          draft.nodes,
          action.objects,
          action.objects.objId
        );
        draft.dicoNameRef = {
          ...draft.dicoNameRef,
          ...extractDicoFormObjFormData(action.objects.objFormData),
        };
        draft.dicoFullRef = {
          ...draft.dicoFullRef,
          ...extractDicoFullFormObjFormData(action.objects.objFormData),
        };
      });
    case OBJECTS_TYPE.CLEAN_OBJECT: {
      return produce(state, (draft) => {
        draft.objFormData = [];
        draft.objLayersRead = [];
        draft.objLayersWrite = [];
        draft.objTypeId = null;
        draft.objId = null;
        draft.crumbTrail = null;
      });
    }
    case OBJECTS_TYPE.SET_LOADING_STATUS: {
      return produce(state, (draft) => {
        draft.isLoadingObjData = action.status;
      });
    }

    case 'SET_OBJECTFORM_FIELD_EDITED': {
      return produce(state, (draft) => {
        draft.objFormFieldEdited = action.fieldName;
      });
    }
    case OBJECTS_TYPE.SAVE_OBJECTFORMDATA:
      return produce(state, (draft) => {
        console.log('IN REDUCER SAVE_OBJECTFORMDATA');
        for (const f of action.objects) {
          // 1) keep objFormData in sync (match by key + attrName)
          const idx = draft.objFormData.findIndex(
            (x) => x.key === f.key && x.attrName === f.attrName
          );
          if (idx >= 0) {
            console.log(
              'IN REDUCER SAVE_OBJECTFORMDATA UPDATING VALUE to %s',
              f
            );
            draft.objFormData[idx] = f;
          } else {
            draft.objFormData.push(f);
          }

          // 2) optimistic node.data patch
          console.log('IN REDUCER SAVE_OBJECTFORMDATA LOOKING FOR:%s', f.key);
          let node = findNodeByKey(draft.nodes, action.objId);
          if (node) {
            node[f.attrName] = f.value;
            console.log(
              'SAVE_OBJECTFORMDATA :updated %s to %s',
              f.attrName,
              f.value
            );
          }
        }
      });

    case OBJECTS_TYPE.ADDED_NODE_TO_LAYER:
      return produce(state, (draft) => {
        draft.objFormData = action.objects.objFormData;
        draft.objId = action.objId ?? draft.objId;
        draft.nodes = replaceObj(draft.nodes, action.objects, draft.objId);
      });
    case OBJECTS_TYPE.SELECTED_DEF_OBJECT:
      return produce(state, (draft) => {
        draft.objDefFormData = action.objects.objFormData;
      });

    case OBJECTS_TYPE.SAVE_CURRENT_PERSPECTIVE:
      return produce(state, (draft) => {});

    case OBJECTS_TYPE.SET_OPEN_MODULE:
      return produce(state, (draft) => {
        draft.openModule = action.moduleId;
      });

    case OBJECTS_TYPE.SET_PANELS:
      return produce(state, (draft) => {
        draft.panels = action.bands_config;
      });

    case OBJECTS_TYPE.GOT_FATHER:
      return produce(state, (draft) => {
        draft.fathers = [...state.fathers, { ...action.objects }];
      });

    case OBJECTS_TYPE.SHIFT_PERSPECTIVE_DOWN:
      return produce(state, (draft) => {
        const father = state.fathers.find(
          (elem) => elem.objId === action.objId
        );
        if (father) {
          const { fatherType } = father;
          const filters1 = {};
          draft.panels = [{ width: 500 }, ...state.panels];

          draft.restrictions = [[], ...state.restrictions];
          draft.restrictions.pop();
          draft.dataLines = [[], ...state.dataLines];
          draft.dataLines.pop();
          draft.dataLines.push([]);
          draft.dataColumns = [[], ...state.dataColumns];
          draft.dataColumns.pop();

          draft.displayMode = ['card', ...state.displayMode];

          let temp = splitPattern(state.pattern);

          temp.pop();
          draft.pattern = joinPattern([fatherType, ...temp]);
          splitPattern(draft.pattern).map((item, ind) => {
            filters1[`level${ind}`] = item;
            return null;
          });
          draft.filters = filters1;
        }
      });

    case OBJECTS_TYPE.SHIFT_PERSPECTIVE_UP:
      return produce(state, (draft) => {
        const filters1 = {};
        draft.panels = [...state.panels];
        draft.panels.shift();
        draft.panels.push({ width: 500 });
        draft.restrictions = [...state.restrictions];
        draft.restrictions.shift();
        draft.dataLines = [...state.dataLines];
        draft.dataLines.shift();
        draft.dataLines.push([]);
        draft.dataColumns = [...state.dataColumns];
        draft.dataColumns.shift();
        draft.dataColumns.push([]);
        draft.displayMode = [...state.displayMode];
        draft.displayMode.shift();
        draft.displayMode.push('card');
        let temp = splitPattern(state.pattern);
        temp.shift();
        draft.pattern = joinPattern([...temp, 'none']);
        splitPattern(draft.pattern).map((item, ind) => {
          filters1[`level${ind}`] = item;
          return null;
        });
        draft.filters = filters1;
      });

    case 'VIEW_CONFIGURATION':
      return produce(state, (draft) => {
        const jsonConfig = JSON.parse(action.payload.configuration);
        draft.dataColumns = jsonConfig.dataColumns;
        draft.displayMode = jsonConfig.displayMode;
        draft.dataLines = jsonConfig.dataLines;
        draft.panels = jsonConfig.panels;
        draft.pattern = jsonConfig.pattern;
        draft.qb_restrictions = DEFAULT_QB_RESTRICTIONS;
        draft.restrictions = DEFAULT_QB_RESTRICTIONS;
        const filters1 = {};
        splitPattern(draft.pattern).map((item, ind) => {
          filters1[`level${ind}`] = item;
          return null;
        });
        draft.filters = filters1;
      });

    case 'VIEW_RESTRICTION':
      return produce(state, (draft) => {
        const jsonConfig = JSON.parse(action.payload.configuration);
        draft.restrictions = jsonConfig;
      });

    case 'OPEN_PERSPECTIVE_BY_ID':
      return produce(state, (draft) => {
        draft.nodes = [];
        draft.arrayClassifBy = Array.from(
          { length: NUM_LEVEL },
          () => 'default'
        );
        draft.childsCountByType = Array.from({ length: NUM_LEVEL }, () => []); // by level
        draft.timeline_shift = Array.from({ length: NUM_LEVEL }, () => 0); // by level
        draft.timeLineCentralDate = Array.from({ length: NUM_LEVEL }, () => -1); // by level
        draft.qb_restrictions = DEFAULT_QB_RESTRICTIONS;
        draft.restrictions = DEFAULT_QB_RESTRICTIONS;
        draft.panels = BANDS_CONFIG;
        draft.pattern = joinPattern(
          Array.from({ length: NUM_LEVEL }, () => 'none')
        ); // by level);

        draft.displayMode = Array.from({ length: NUM_LEVEL }, () => 'card'); // by level;
        draft.dataColumns = Array.from({ length: NUM_LEVEL }, () => []); // by level
        draft.dataLines = Array.from({ length: NUM_LEVEL }, () => []); // by level
        draft.filters = Object.fromEntries(
          Array.from({ length: NUM_LEVEL }, (_, i) => [`level${i}`, 'none'])
        );
        draft.viewfiltersConfig = [];
      });

    case OBJECTS_TYPE.VIEW_FILTERS_CONFIG_SET: {
      const safe = Array.isArray(action.payload) ? action.payload : [];
      return { ...state, viewFiltersConfig: safe };
    }

    case OBJECTS_TYPE.OPEN_PERSPECTIVE:
      const { objId } = state;
      const res = {
        ...state,
        ...preParseDataOpenPerspective({ action, objId }),
      };

      res.arraySortByWithType = res.arraySortBy.map((item, ind) => {
        let colType = splitPattern(res.pattern)[ind];
        let typeOfField = getTypeOfField(state.objectsDefList, colType, item);
        return {
          key: item,
          type: typeOfField ?? 'text',
        };
      });

      return res;

    case OBJECTS_TYPE.RECEIVED_OBJECTS:
      return produce(state, (draft) => {
        draft.objectsReceived = action.objects;
        draft.dicoNameRef = {
          ...draft.dicoNameRef,
          ...extractDicoFormObjFormData(action.objects.objFormData),
        };
      });

    case OBJECTS_TYPE.RECEIVED_PROFILES:
      return produce(state, (draft) => {
        draft.profiles = action.objects.reduce(
          (
            acc,
            { objId, initials, name, profilecolor, email, photo, photoOrigName }
          ) => {
            acc[objId] = {
              initials,
              objId,
              profilecolor,
              email,
              name,
              photo,
              photoOrigName,
            };
            return acc;
          },
          {}
        );
      });

    case OBJECTS_TYPE.REFRESHED_OBJECT:
      return produce(state, (draft) => {
        draft.nodes = replaceObj(
          draft.nodes,
          action.objects,
          action.objects.objId
        );
        draft.dicoNameRef = {
          ...draft.dicoNameRef,
          ...extractDicoFormObjFormData(action.objects.objFormData),
        };
        draft.dicoFullRef = {
          ...draft.dicoFullRef,
          ...extractDicoFullFormObjFormData(action.objects.objFormData),
        };
      });

    case OBJECTS_TYPE.SET_VIEW_FILTERS:
      return produce(state, (draft) => {
        draft.viewFilters = action.viewFilters;
        draft.viewFiltersRestrictions = action.viewFiltersRestrictions;
      });

    case OBJECTS_TYPE.REQUEST_TREE_BY_PATTERN:
      return produce(state, (draft) => {
        if (action.pattern !== draft.pattern) {
          let parts = splitPattern(action.pattern);
          parts.map((item, ind) => {
            draft.filters[`level${ind}`] = item;
            return null;
          });
          draft.pattern = action.pattern;
        }
      });

    case OBJECTS_TYPE.STARTED_DRAGGING_NODE: {
      console.log('action______0');
      return produce(state, (draft) => {
        draft.dragged_node_key = action.key;
        draft.draggedObjectFormData = action.promise;
        draft.dragged_node_origin_panel = draft.activePanel;
      });
    }

    case OBJECTS_TYPE.RECEIVED_DRAGGED_OBJECT: {
      console.log('action______1');

      return produce(state, (draft) => {
        draft.draggedObjectFormData = action.objects.objFormData;
      });
    }

    case OBJECTS_TYPE.SET_DRAGGED_OVER:
      return produce(state, (draft) => {
        draft.dragged_over = action.objId;
      });

    case OBJECTS_TYPE.SET_DRAGGED_OBJECT: {
      console.log('action______2');

      return produce(state, (draft) => {
        const arrayName = action.objFormData.filter(
          (item) => item.attrName === 'name'
        );
        const key = arrayName[0].key.substring(0, 9);
        draft.nodes = replaceObj(draft.nodes, action.objFormData, key);
        draft.draggedObjectFormData = action.objFormData;
      });
    }

    case OBJECTS_TYPE.SET_SELECTED_OBJECT:
      return produce(state, (draft) => {
        const arrayName = action.objFormData.filter(
          (item) => item.attrName === 'name'
        );
        const key = arrayName[0].key.substring(0, 9);
        draft.nodes = replaceObj(draft.nodes, action.objFormData, key);
        draft.objFormData = action.objFormData;
      });

    case OBJECTS_TYPE.SET_GLOBAL_VALUE:
      return produce(state, (draft) => {
        draft.globalValues[action.globValueId] = action.val;
      });

    case OBJECTS_TYPE.SET_CLASSIFX:
      return produce(state, (draft) => {
        draft.arrayClassifBy = Array.from(
          { length: NUM_LEVEL },
          () => 'default'
        ).map((item, ind) =>
          ind === draft.activePanel
            ? action.paramClassifX
            : draft.arrayClassifBy[ind] ?? item
        );
        draft.classifX = draft.arrayClassifBy[draft.activePanel];
      });

    case OBJECTS_TYPE.SET_CLASSIFY:
      return produce(state, (draft) => {
        draft.classifY = action.paramClassifY;
      });

    case OBJECTS_TYPE.SELECT_CONTEXT:
      return produce(state, (draft) => {
        draft.context = draft.context == 'nbChild' ? 'nbRandom' : 'nbChild';
      });

    case OBJECTS_TYPE.UP_CONTEXT:
      return produce(state, (draft) => {
        draft.contextInd = (draft.contextInd + 1) % contextTable.length;
        draft.context = contextTable[draft.contextInd];
      });
    case OBJECTS_TYPE.DOWN_CONTEXT:
      return produce(state, (draft) => {
        draft.contextInd =
          draft.contextInd - 1 < 0
            ? contextTable.length - 1
            : state.contextInd - 1;
        draft.context = contextTable[draft.contextInd];
      });

    case OBJECTS_TYPE.RECEIVE_EVENTS:
      return produce(state, (draft) => {
        draft.events = { list: action.objects.list };
      });

    case OBJECTS_TYPE.RECEIVE_TREE:
      if (action.success) {
        let json = {};
        collectNamerefProperties(action.objects, json);
        return produce(state, (draft) => {
          draft.nodes = action.objects;

          draft.node0 = action.objects?.[0]?.key ?? null;
          draft.dicoNameRef = {
            ...draft.dicoNameRef,
            ...json,
            ...extractDicoFormObjFormData(draft.objFormData),
          };
        });
      }
      console.log('RECEIVE_TREE ERROR, could be abort'); // could be abort
      return state;

    case OBJECTS_TYPE.RECEIVED_TEMPLATE_OBJECTS:
      return produce(state, (draft) => {
        draft.templateObjects = action.objects;
      });

    case OBJECTS_TYPE.RECEIVED_PERSPECTIVES:
      return produce(state, (draft) => {
        draft.perspectives = action.objects;
      });
    case OBJECTS_TYPE.SET_LOADING_PERSPECTIVE:
      return produce(state, (draft) => {
        draft.isLoadingPerspectives = action.value;
      });
    case OBJECTS_TYPE.RECEIVE_SEARCH_RESULT:
      return produce(state, (draft) => {
        draft.nodes = action.objects;
        draft.pattern = joinPattern(
          Array.from({ length: NUM_LEVEL }, () => 'all')
        ); // by level);
        draft.filters = Object.fromEntries(
          Array.from({ length: NUM_LEVEL }, (_, i) => [`level${i}`, 'all'])
        );
      });
    case OBJECTS_TYPE.RECEIVE_LAYERS:
      return produce(state, (draft) => {
        draft.layers = action.objects;
      });
    case OBJECTS_TYPE.FILTER_SET_LEVEL:
      return produce(state, (draft) => {
        draft.filters[`level${action.level}`] = action.val;
        // Set values with indices greater than action.level to "none"
        for (let i = action.level + 1; i < NUM_LEVEL; i++) {
          draft.filters[`level${i}`] = 'none';
        }
        draft.dataColumns[action.level] = [
          {
            to: action.val,
            data: 'name',
            w: 100,
            type: 'text',
          },
        ];
        draft.pattern = joinPattern(
          Object.keys(draft.filters)
            .sort() // "level0", "level1", ...
            .map((k) => draft.filters[k])
        );
      });
    case OBJECTS_TYPE.RECEIVED_CRUMBTRAIL:
      return produce(state, (draft) => {
        draft.crumbTrail = action.objects;
        draft.isLoadingCrumbTrail = false;
      });
    case OBJECTS_TYPE.RECEIVED_SOCIAL:
      return produce(state, (draft) => {
        draft.social_content = action.objects;
      });
    case OBJECTS_TYPE.RECEIVE_OBJECTS:
      return produce(state, (draft) => {
        const odl = draft.nodes;
        const listNode = new Array();
        listNode.push.apply(listNode, odl);
        let stop = false;
        while (!stop && !listNode.length === 0) {
          const currObj = listNode.pop();

          if (currObj.key === action.objId) {
            stop = true;
            currObj.children = action.objects;
          } else if (currObj.children !== null)
            listNode.push.apply(listNode, currObj.children);
        }
        draft.nodes = listNode;
      });
    case OBJECTS_TYPE.SET_STATUS_OBJECT_DEFINITION:
      return produce(state, (draft) => {
        draft.isLoadingObjectConfig = action.status;
        draft.isLoadingObjectsDefList = action.isLoadingObjectsDefList;
      });
    case OBJECTS_TYPE.SAVE_OBJECT_DEFINITION:
      return produce(state, (draft) => {
        draft.objectsDefList = [];
      });
    case OBJECTS_TYPE.RECEIVED_CHILDS_COUNT_BY_TYPE:
      return produce(state, (draft) => {
        draft.childsCountByType[action.level] = action.objects;
        draft.isLoadingTree[action.level] = action.value;
      });
    case OBJECTS_TYPE.RECEIVED_OBJECTS_DEF_LIST:
      return produce(state, (draft) => {
        draft.objectsDefList =
          action.objects != null
            ? action.objects.sort((a, b) => a.label.localeCompare(b.label))
            : null;
        draft.pattern = getRealPatternFromPrefixes(
          draft.pattern,
          draft.objectsDefList
        );
        draft.field_type = [
          ...fixed_field_type,
          ...(action.objects
            ? action.objects.map((elem) => {
                return {
                  label: elem.label,
                  description: elem.description,
                  name: elem.key,
                  icon: 'anchor.png',
                  predefined: false,
                };
              })
            : []),
        ];
        draft.dicoNameRef = {
          ...state.dicoNameRef,
          ...(action.objects
            ? action.objects.reduce(
                (acc, a) => extractDicoFormObjFormData(a.objFormData, acc),
                {}
              )
            : []),
        };
        draft.dicoFullRef = {
          ...state.dicoFullRef,
          ...(action.objects
            ? action.objects.reduce(
                (acc, a) =>
                  extractDicoFullFormObjFormData(a.objFormData, acc, a.key),
                {}
              )
            : []),
        };
      });
    case OBJECTS_TYPE.SAVE_OBJECT:
      return produce(state, (draft) => {});
    case OBJECTS_TYPE.SET_LOADING_CRUMB_TRAIT:
      return produce(state, (draft) => {
        draft.isLoadingCrumbTrail = action.status;
      });
    case OBJECTS_TYPE.RESET_CRUMB_TRAIL:
      return produce(state, (draft) => {
        draft.crumbTrail = null;
      });
    case OBJECTS_TYPE.OPEN_ACTIVITY_FROM_VERTICAL:
      return produce(state, (draft) => {
        draft.isOpenActivityFromVertical = action.status;
      });

    default:
      return state;
  }
};
export default objects;
